import { ModuleFE_ClinicalForm } from './ModuleFE_ClinicalForm.js';
export const ModulePackFE_ClinicalFormDB = [ModuleFE_ClinicalForm];
//# sourceMappingURL=module-pack.js.map